import Program from 'models/Program';
import MentorApplication from 'models/MentorApplication';
import MemberApplication from 'models/MemberApplication';

// TODO: When MemberApplication statuses become consecutive integers, consider refactoring this file to use one function for both Member and Mentor applications

export const getProgramStageByMemberApplicationStatus = status => {
  switch (status) {
    // Application
    case MemberApplication.STATUS_IN_PROGRESS:
      return Program.PROGRAM_STAGE_APPLICATION;
    // Selection
    case MemberApplication.STATUS_PENDING_DECISION:
      return Program.PROGRAM_STAGE_SELECTION;
    // Approved
    case MemberApplication.STATUS_APPROVED_NO_EMAIL:
    case MemberApplication.STATUS_APPROVED_ONBOARDING_SESSION:
      return Program.PROGRAM_STAGE_APPROVED;
    // Matching
    case MemberApplication.STATUS_UNMATCHED:
    case MemberApplication.STATUS_MATCHED:
      return Program.PROGRAM_STAGE_MATCHING;
    // Incubating
    case MemberApplication.STATUS_INCUBATING:
      return Program.PROGRAM_STAGE_INCUBATING;
    // Alumni
    case MemberApplication.STATUS_ALUMNI:
      return Program.PROGRAM_STAGE_ALUMNI;
    default:
      return undefined;
  }
};

export const getProgramStageByMentorApplicationStatus = status => {
  switch (status) {
    // Application
    case MentorApplication.STATUS_IN_PROGRESS:
      return Program.PROGRAM_STAGE_APPLICATION;
    // Selection
    case MentorApplication.STATUS_PENDING_DECISION:
      return Program.PROGRAM_STAGE_SELECTION;
    // Approved
    case MentorApplication.STATUS_APPROVED_NO_EMAIL:
    case MentorApplication.STATUS_APPROVED_ONBOARDING_SESSION:
      return Program.PROGRAM_STAGE_APPROVED;
    // Matching
    case MentorApplication.STATUS_UNMATCHED:
    case MentorApplication.STATUS_MATCHED:
      return Program.PROGRAM_STAGE_MATCHING;
    // Incubating
    case MentorApplication.STATUS_INCUBATING:
      return Program.PROGRAM_STAGE_INCUBATING;
    // Alumni
    case MentorApplication.STATUS_ALUMNI:
      return Program.PROGRAM_STAGE_ALUMNI;
    default:
      return undefined;
  }
};
